<!-- 改厕档案信息 -->
<template>
  <div class="main-area">
    <div v-if="$route.meta.rank == 3">
    <el-breadcrumb separator=":">
      <el-breadcrumb-item>当前位置</el-breadcrumb-item>
      <el-breadcrumb-item>{{ pageTitle }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!--查询区域-->
    <el-row class="margin-top-10">
      <el-col
        :span="2"
        class="margin-top-10">
        <label class="search-label">区划:</label>
      </el-col>
      <el-col
        :span="4"
        class="margin-top-10">
        <el-cascader
          :options="options"
          :props="optionProps"
          v-model="searchForm.selectvalue"
          change-on-select="ture"
          clearable
          size="mini"
          @change="test"
        />
      </el-col>
      <el-col :span="2"  style="text-align: right" class="margin-top-10">
          <label class="search-label">
            起止时间:
          </label>
        </el-col>
        <el-col :span="10" class="margin-top-10" style="text-align: left">
          <div class="block" >
            <el-date-picker
              :size="GLOBAL.config.systemSize"
              v-model="searchForm.timeTwo.beginTime"
              type="datetime"
              value-format="yyyyMMddHHmmss"
              :picker-options="pickerOptions"
              placeholder="选择开始日期时间">
            </el-date-picker>
            <el-date-picker
              :size="GLOBAL.config.systemSize"
              v-model="searchForm.timeTwo.endTime"
              type="datetime"
              value-format="yyyyMMddHHmmss"
              :picker-options="pickerOptions"
              placeholder="选择结束日期时间">
            </el-date-picker>
          </div>
        </el-col>
      <el-col
        :span="2"
        class="margin-top-10">
        <el-button
          type="primary"
          @click="doSearch"
          :size="GLOBAL.config.systemSize"
          icon="el-icon-search"
        >查询</el-button>
      </el-col>
      <el-col
        :span="2"
        class="margin-top-10">
        <el-button
          type="primary"
          @click="changeType"
          :size="GLOBAL.config.systemSize"
        >{{ btnTitle }}</el-button>
      </el-col>
    </el-row>
    <div class="content">
      <!-- 图标显示 -->
      <div class="Echarts margin-top-30">
        <div style="text-align:left;font-weight:600;margin-left:20px">数据来源：{{selectName||'肥东县'}}</div>
        <div
          id="main"
          style="width: 580px;height:400px;"/>
      </div>
      <!-- 表格显示 -->
      <el-table
        class="form"
        :data="tableData"
        border
        style="width:410px; margin-left: 30px;">
        <el-table-column
          label="一星评价"
          width="80px"
          align="center"
          prop="onePj"
        />
        <el-table-column
          label="二星评价"
          width="80px"
          align="center"
          prop="twoPj"
        />
        <el-table-column
          label="三星评价"
          width="80px"
          align="center"
          prop="threePj"
        />
        <el-table-column
          label="四星评价"
          width="80px"
          align="center"
          prop="fourPj"
        />
        <el-table-column
          label="五星评价"
          align="center"
          prop="fivePj"/>
      </el-table>
    </div>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import cascader from '../../components/Cascader'
import _ from 'loadsh'
export default {
  name: 'SatisfactionAnalysis',

  components: {
    cascader
  },

  data () {
    return {
      btnTitle: '切换排行',
      pageTitle: '报抽满意度排行',
      dataType: '1', // 1 报抽 2 维修
      searchForm: {
        ssqh: '',
        hzsjh: '',
        hz: '',
        selectvalue: '', // 区域选,的值
        updateTime: '',
        timeTwo: {beginTime: '', endTime: ''}
      },
      selectName:'',
      options: JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.orgTreeName))),
      optionProps: {
        // checkStrictly: true,
        value: 'code',
        label: 'name',
        children: 'organizationList'
      }, // 区域自定义匹配值
      source: {
        add: true,
        deleteBatch: true,
        export: true,
        import: true,
        infoView: true,
        infoEdit: true,
        infoDelete: true,
        exportTemplate: true
      },
      loading: false,
      tableData: [],
      deleteBatchList: {
        ids: [],
        deleteFlag: false
      },
      // 所属区域
      setProps: {
        multiple: false, // 单选
        checkStrictly: true, // 父节点取消选中关联
        value: 'code',
        label: 'name',
        children: 'children',
        leaf: 'leaf'
      },
      viewVisibleFlag: false,
      url:
        this.CONFIG.urls.root +
        this.CONFIG.urls.business.downLoad +
        '/importVillageData',
      data: {},
      fileList: [],
      // 图表数据
      xAxis: ['一星评价', '二星评价', '三星评价', '四星评价', '五星评价'],
      yAxis: [],
      tempData: {
          bc: [],
          bx: []
      },
      barData: {
          bc: [],
          bx: []
      },
        pickerOptions: {
            disabledDate(time) {
                return time.getTime() > Date.now()
            }
        }
    }
  },
  watch: {
    $route (to, from) {
      let _this = this
      if (to.path === '/dataAnalysis/SatisfactionAnalysis') {
        setTimeout(function () {
          _this.myEcharts()
        }, 100)
      }
    }
  },
  methods: {
		changeType () {
      if (this.dataType === '1') {
          this.pageTitle = '报修满意度排行'
          this.dataType = '2'
          this.$message.success('已切换至报修满意度排行')
          this.tableData = [...this.tempData.bx]
          this.yAxis = Object.values(this.barData.bx)
          this.myEcharts()
      } else {
          this.pageTitle = '报抽满意度排行'
          this.dataType = '1'
          this.$message.success('已切换至报抽满意度排行')
          this.tableData = [...this.tempData.bc]
          this.yAxis = Object.values(this.barData.bc)
          this.myEcharts()
      }
    },
    doSearch () {
        if (this.searchForm.timeTwo.beginTime && this.searchForm.timeTwo.endTime) {
            if (!this.FUNCTIONS.systemFunction.compareDate(this.searchForm.timeTwo.beginTime, this.searchForm.timeTwo.endTime)) {
                this.$message.warning('开始日期不能大于结束日期！')
                return
            }
        }
      this.getTableData()
    },
    getTableData (initPageFlag) {
      this.loading = true
      const _this = this
      const searchParams = this.searchForm
      _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)

      // 3、 调接口获取数据
      const param = {
        baseService: _this.GLOBAL.config.baseServiceType.TGcBxxxServiceImpl,
        code: _this.searchForm.selectvalue ? _this.searchForm.selectvalue[0] : '',
        beginTimes: _this.searchForm.timeTwo.beginTime||'',
        endTimes:_this.searchForm.timeTwo.endTime||''

      }
      _this.FUNCTIONS.systemFunction.interactiveData(
        _this,
        _this.GLOBAL.config.businessFlag.zxUser,

        _this.GLOBAL.config.handleType.getAllMyd,
        param,
        null,
        resultData => {
          _this.loading = false
          if (resultData) {
              const { obj } = resultData
              const { bcone, bctwo, bcthree, bcfour, bcfive, bxone, bxtwo, bxthree, bxfour, bxfive } = obj
              this.barData.bc = {
                  bcone: bcone,
                  bctwo: bctwo,
                  bcthree: bcthree,
                  bcfour: bcfour,
                  bcfive: bcfive
              }
              this.barData.bx = {
                  bxone: bxone,
                  bxtwo: bxtwo,
                  bxthree: bxthree,
                  bxfour: bxfour,
                  bxfive: bxfive
              }
              this.tempData.bc = [{
                  onePj: bcone ? (bcone + '%') : '0%',
                  twoPj: bctwo ? (bctwo + '%') : '0%',
                  threePj: bcthree ? (bcthree + '%') : '0%',
                  fourPj: bcfour ? (bcfour + '%') : '0%',
                  fivePj: bcfive ? (bcfive + '%') : '0%'
              }]
              this.tempData.bx = [{
                  onePj: bxone ? (bxone + '%') : '0%',
                  twoPj: bxtwo ? (bxtwo + '%') : '0%',
                  threePj: bxthree ? (bxthree + '%') : '0%',
                  fourPj: bxfour ? (bxfour + '%') : '0%',
                  fivePj: bxfive ? (bxfive + '%') : '0%'
              }]
              if (this.dataType === '1') {
                  this.yAxis = Object.values(this.barData.bc)
                  this.tableData=[ ...this.tempData.bc ]
              } else {
                  this.yAxis = Object.values(this.barData.bx)
                  this.tableData=[ ...this.tempData.bx ]
              }
              this.myEcharts()
          } else {
            _this.$message.warning('获取列表数据失败～')
          }
        },
        () => {
          _this.loading = falsed
        }
      )
    },
    // 图表方法
    myEcharts () {
      const myChart = this.$echarts.init(
        document.getElementById('main'),
        'light'
      )
      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: 'category',
          data: ['一星评价', '二星评价', '三星评价', '四星评价', '五星评价']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.yAxis,
            type: 'bar',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(220, 220, 220, 0.8)'
            }
          }
        ],
        toolbox: {
          show: true,
          feature: {
            // dataView: {show: true, readOnly: false},
            // magicType: {show: true, type: ['pie', 'line', 'bar']},
            // restore: {show: true},
            saveAsImage: {show: true}
          }
        },
      })
      let _this = this
      myChart.on('click', function(data) {
        console.log(_this.dataType)
        console.log(data)
        _this.$router.push({
          name: 'satisfactionTable',
          params: {
            dataType: _this.dataType,
            ssqh: _this.searchForm.selectvalue ? _this.searchForm.selectvalue[0] : '',
            beginTimes: _this.searchForm.timeTwo.beginTime||'',
            endTimes:_this.searchForm.timeTwo.endTime||'',
            pj: data.dataIndex + 1
          }
        })
      })
    },
    formatData (arr) {
      const result = []
      arr.map(item => {
        result[Object.keys(item)[0]] = Object.values(
          item[Object.keys(item)[0]]
        )
      })
      // this.yAxis = result['店埠镇']
      return result
    },
    test(val){
     let index = _.findIndex(this.options,{code:val?val[0]:''})
      let obj = this.options[index];
      this.selectName=obj?obj.name:''

    }
  },
  mounted () {
      this.getTableData()
  }
}
</script>

<style scoped>
.upload-demo {
  text-align: left !important;
}

.box {
  display: flex;
}

.left {
  width: 50%;
}

.tight {
  width: 50%;
}
/* .content {
  display: flex;
} */
.Echarts {
  float: left;
}
.form {
  float: left;
  margin-top: 100px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/view/DataAnalysis/SatisfactionAnalysis.vue